import { Box, styled } from "@mui/system";
import React, { FC, useState } from "react";
import muiIcons from "../icons/mui-icons";
import { GullButton } from "../buttons/GullButton";
import { Paragraph } from "../Typography";
import {
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  Popover,
} from "@mui/material";

const ListButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: "5px",
  padding: "6px 12px",
  width: "80px",
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

interface Props {
  userId: number | string;
  mainTableData: any[];
  setFilteredTableData: (value: any[]) => void;
}
const SortedTableAction: FC<Props> = (props) => {
  const { WarningIcon } = muiIcons;
  const { userId, mainTableData, setFilteredTableData } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openAction, setOpenAction] = useState(false);
  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpenAction(true);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setOpenAction(false);

  const [warningModal, setWarningModal] = useState(false);
  const closeModal = () => {
    setWarningModal(false);
    setOpenAction(false);
  };

  const deletedData = (id: string | number) => {
    const deleted = mainTableData.filter((data) => data.id !== id);
    setFilteredTableData(deleted);
    closeModal();
  };

  return (
    <>
      <GullButton
        color="primary"
        variant="outlined"
        sx={{ p: ".2rem 1.2rem", fontWeight: "bold" }}
        onClick={(e) => handleOpen(e)}
      >
        Action
      </GullButton>
      <Popover
        open={openAction}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List sx={{ px: "8px" }}>
          <ListItem disablePadding>
            <ListButton>View</ListButton>
          </ListItem>
          <ListItem disablePadding>
            <ListButton onClick={() => setWarningModal(true)}>
              Delete
            </ListButton>
          </ListItem>
        </List>
      </Popover>

      <Dialog open={warningModal}>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "2rem 5rem",
          }}
        >
          <WarningIcon
            sx={{
              mt: "10px",
              color: "warning.main",
              fontSize: 90,
            }}
          />
          <Paragraph sx={{ py: "20px", fontSize: 18 }}>
            Are you sure you to delete it?
          </Paragraph>
          <Box>
            <GullButton
              color="warning"
              variant="contained"
              onClick={() => deletedData(userId)}
              sx={{
                mt: "10px",
                p: ".5rem 1rem",
                fontSize: 16,
              }}
            >
              Delete
            </GullButton>
            <GullButton
              color="primary"
              variant="contained"
              onClick={closeModal}
              sx={{
                mt: "10px",
                p: ".5rem 1rem",
                fontSize: 16,
              }}
            >
              Cancel
            </GullButton>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SortedTableAction;
